import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogClose, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { AbstractControl, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { TranslateModule } from "@ngx-translate/core";
import { AppUrlConstants } from '../../../core/constants/AppUrlConstants';
import { GenericCrudService } from '../../../core/services/generic-crud.service';
import { AlertDialogComponent } from '../../../shared/alert-dialog/alert-dialog.component';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { AuthenticationService } from '../../../core/services/authentication.service';
import { MatCheckbox } from '@angular/material/checkbox';
import { ProcessEnum } from '../../../core/enums/processSteps.enum';
import { ProcessPipe } from "../../../core/pipes/process.pipe";

@Component({
    selector: 'app-add-edit-work-flow-step',
    standalone: true,
    templateUrl: './add-edit-work-flow-step.component.html',
    imports: [MatDialogModule, MatFormFieldModule, MatInputModule, FormsModule, MatButtonModule,
        ReactiveFormsModule, MatDialogClose, TranslateModule, MatOptionModule, MatSelectModule, MatCheckbox, ProcessPipe]
})
export class AddEditWorkFlowStepComponent {
  form: FormGroup;
  processStepKeys = ProcessEnum.keys();
  processSteps: any[] = [];
  filteredListprocessSteps:any[] = [];
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<AddEditWorkFlowStepComponent>,
    public dialog: MatDialog, private formBuilder: FormBuilder,
    private crudService: GenericCrudService, private authService: AuthenticationService) {
  }
  ngOnInit() {
    this.getBySegment(this.authService.getUserSegment());
    this.form = this.formBuilder.group({
      complaintProcessId: [null],
      name: ['', [Validators.required, Validators.maxLength(30)]],
      description: ['', [Validators.required, Validators.maxLength(300)]],
      segmentId: [this.authService.getUserSegment()],
      predecessorProcessId: [null],
      successorProcessId: [null],
      processType: ['NORMAL'],
      existingDefaultProcessId: [null]
    });
    if (this.data != null) {
      const newData = {...this.data};
      delete newData.orderBy;
      if (!newData?.complaintProcessId) {
        this.form.get('existingDefaultProcessId')?.setValue(newData?.existingDefaultProcessId);
      } else {
        this.form.setValue(newData);
      }
    }
  }
  getBySegment(id: number) {
    this.crudService.getById(id, AppUrlConstants.COMPLAINT_PROCESS_URL + AppUrlConstants.SEGMENT).subscribe({
      next: (res: any) => {
        this.processSteps = res?.data;
        // Initialize filtered list for processSteps
        this.filteredListprocessSteps = this.onFilteredListSearch(null, this.processSteps, 'name');
      },
      error: (e) => {
      }
    });
  }
  add() {
    this.crudService.add(this.form.value, AppUrlConstants.COMPLAINT_PROCESS_URL + AppUrlConstants.ADD).subscribe({
      next: (res: any) => {
        this.dialogRef.close(res?.data);
      },
      error: (e) => {
        if (e?.status == 409) {
          if (e?.error?.errors !== null) {
            for (const property in e.error.errors) {
              this.openAlert(e.error.errors[property]);
            }
          } else {
            this.openAlert(e?.error?.message);
          }
        }
      }
    });
  }
  edit() {
    this.crudService.edit(this.form.value, AppUrlConstants.COMPLAINT_PROCESS_URL + AppUrlConstants.EDIT).subscribe({
      next: (res: any) => {
        this.dialogRef.close(res?.data);
      },
      error: (e) => {
        if (e?.status == 409) {
          if (e?.error?.errors !== null) {
            for (const property in e.error.errors) {
              this.openAlert(e.error.errors[property]);
            }
          } else {
            this.openAlert(e?.error?.message);
          }
        }
      }
    });
  }
  openAlert(message: string) {
    const dialogRef = this.dialog.open(AlertDialogComponent, {
      data: {
        message: message,
        buttonText: {
          cancel: 'OK'
        }
      },
    });
  }
  get f(): { [key: string]: AbstractControl } {
    return this.form.controls;
  }

  onProcessTypeSelect() {
    this.form.enable();
    const values = this.form.value;
    if (values?.processType === 'CLOSED_PROCESS') {
      this.form.get('successorProcessId')?.disable();
    } else if (values?.processType === 'DEFAULT_PROCESS') {
      if (values?.existingDefaultProcessId && values?.processType == 'DEFAULT_PROCESS') {
        this.form.get('processType')?.setErrors({ defaultProcessExist: true });
      }
      this.form.get('predecessorProcessId')?.disable();
    }
  }

  onFilteredListSearch(event: any, originalList: any[], property: string): any[] {
    let filteredList: any[];
    if (event && event.target.value) {
      filteredList = originalList.filter(item => item[property].toLowerCase().includes(event.target.value.toLowerCase()));
    } else {
      filteredList = originalList; // Copy the original list
    }
    return filteredList;
  }

  // onOptionSelected(event: any, formControlName: string) {
    onOptionSelected(event: any) {
  
    const searchInput = document.getElementById('search-select') as HTMLInputElement;
    if (searchInput) {
      searchInput.value = '';
    }
    // Reset the filtered list to the original list
    // if (formControlName === 'predecessorProcessId' || formControlName === 'successorProcessId') {
      this.filteredListprocessSteps = this.processSteps;
    // };
  }
}
